{
  "exclusiveOverviewPage.title": "專屬存取",
  "exclusiveOverviewPage.notification.permanent.learnMoreLinkText": "深入瞭解",
  "exclusiveOverviewPage.notification.permanent": "永久專屬存取是您永久凍結網站的 URL，僅特定成員可存取。您可同時提供並管理多個專屬存取類型。{learnMoreLink}。",
  "exclusiveOverviewPage.notification.limited.learnMoreLinkText": "深入瞭解",
  "exclusiveOverviewPage.notification.limited": "有限專屬存取是您暫時凍結網站的 URL，僅特定成員可存取。存取有效性與專屬期間相同。專屬期間到期後，無法再次存取專屬。{learnMoreLink}。",
  "exclusiveOverviewPage.card.activeAndConnectedTooltip": "專屬為啟用中，存取連接至：{text}",
  "exclusiveOverviewPage.card.activeReadyToConnectTooltip": "凍結為啟用中，已準備連接存取。",
  "exclusiveOverviewPage.card.deactivatedTooltip": "您已停用專屬，現在可編輯並將其重新啟用。",
  "exclusiveOverviewPage.card.inactiveTooltip": "未完成設定。",
  "exclusiveOverviewPage.card.expiredTooltip": "此專屬已到期。您可複製和編輯此專屬。",
  "exclusiveOverviewPage.card.scheduledTooltip": "此專屬已排程於 {text}",
  "exclusiveOverviewPage.card.info.offersAndValidity": "優惠和有效性",
  "exclusiveOverviewPage.card.info.accessAsFixedBenefit": "固定福利存取",
  "exclusiveOverviewPage.card.info.accessAsAdditionalBenefits": "其他福利存取",
  "exclusiveOverviewPage.card.info.accessAsReward": "行動獎勵存取",
  "exclusiveOverviewPage.card.info.accessForPoints": "點數存取",
  "exclusiveOverviewPage.card.info.accessForFree": "免費存取",
  "exclusiveOverviewPage.card.connectedTo": "已連接至",
  "exclusiveOverviewPage.card.walletInTooltip": "忠誠錢包/API",
  "exclusiveOverviewPage.card.deleteDialog.headline": "您確定要刪除此存取嗎？",
  "exclusiveOverviewPage.card.deleteDialog.content": "刪除存取後，存取不再專屬且所有 URL 區塊將移除。",
  "exclusiveOverviewPage.card.newCardText": "建立 {value}",
  "exclusiveOverviewPage.filters.search.label": "搜尋",
  "exclusiveOverviewPage.filters.status.label": "狀態",
  "exclusiveSetupPage.confirmMultilang.headline": "您確定已完成專屬設定？",
  "exclusiveSetupPage.confirmMultilang.content": "您未定義所有現有語言的 URL，專屬存取不適用於沒有定義 URL 的語言。",
  "exclusiveSetupPage.errors.editorStep": "輸入所有四個凍結版本。",
  "exclusiveSetupPage.exclusiveAccessAndOffer.notification": "您不需要設定點數，但可加以使用以提供成員此點數存取。",
  "exclusiveSetupPage.multiLangPopupTitle": "以語言為基礎的 URL",
  "exclusiveSetupPage.activeEditAlert": "您正在編輯啟用中專屬，該變更將立即影響成員。",
  "exclusiveAccessCustomHtmlEditor.editorSide.emptyContentPlaceholder.heading": "在此處貼上或輸入您的 HTML 程式碼。",
  "exclusiveAccessCustomHtmlEditor.editorSide.emptyContentPlaceholder.content": "您可在此處拖放您的來源檔案。",
  "exclusiveAccessCustomHtmlEditor.previewSide.emptyContentPlaceholder.heading": "在此處貼上或輸入您的 HTML 程式碼。",
  "exclusiveAccessCustomHtmlEditor.previewSide.emptyContentPlaceholder.content": "凍結頁面預覽會顯示在此處。",
  "stylePicker.overlayColor.label": "覆蓋色彩",
  "stylePicker.overlayOpacity.label": "覆蓋不透明度",
  "stylePicker.contentBackgroundColor.label": "內容背景色彩",
  "stylePicker.tagColor.label": "標籤色彩",
  "stylePicker.tagRadius.label": "標籤半徑",
  "stylePicker.leftButtonBackgroundColor.label": "按鈕 1 背景色彩",
  "stylePicker.rightButtonBackgroundColor.label": "按鈕 2 背景色彩",
  "stylePicker.buttonRadius.label": "按鈕半徑",
  "linkPickers.leftButtonLink.label": "按鈕 1 連結",
  "linkPickers.rightButtonLink.label": "按鈕 2 連結",
  "exclusiveAccessCustomTemplateEditor.styleEditorSidebar.sidebarBody.title": "凍結頁面編輯器",
  "exclusiveAccessCustomTemplateEditor.highlightEditable.switch.label": "醒目提示可編輯內容",
  "linkDialog.linkDialogPopup.title": "連結編輯器",
  "linkDialog.lsOpenWalletCb.label": "成員按一下按鈕後顯示錢包。",
  "linkButtonOptions.return.name": "返回上一頁。",
  "linkButtonOptions.redirect.name": "新增重新導向 URL",
  "stylePickerBar.closeButtonPoitionOptions.topRight": "右上方",
  "stylePickerBar.closeButtonPoitionOptions.topLeft": "左上方",
  "memberModTabs.member.value": "成員",
  "memberModTabs.nonMember.value": "非成員",
  "exclusiveAccessSetupSettings.accessName.label": "存取名稱",
  "validityPeriodSetup.accessValidityType.placeholder": "選擇存取有效性選項",
  "validityPeriodSetup.accessValidity.duration.label": "選擇有效性",
  "exclusiveAccessAndOffer.redemptionMessageTooltip.free": "輸入要為此存取在忠誠錢包中顯示的優惠訊息，這允許成員取得優惠。",
  "exclusiveAccessAndOffer.redemptionMessageTooltip.points": "輸入要為此存取在忠誠錢包中顯示的優惠訊息，內文欄位包含每個層級定義的點數權杖值。",
  "exclusiveAccessAndOffer.offerMessage.header": "優惠訊息",
  "exclusiveAccessAndOffer.offerMessage.title.label": "標題",
  "exclusiveAccessAndOffer.offerMessage.text.label": "內文",
  "exclusiveAccessAndOffer.offerRestriction.title": "優惠限制",
  "exclusiveAccessAndOffer.offerRestriction.tooltip": "輸入成員可在啟用中期間取得此存取的次數。啟用新優惠後，便會重設此限制。",
  "exclusiveAccessAndOffer.offerRestriction.limitValue.label": "優惠數量",
  "exclusiveAccessAndOffer.offerStatusAnbValidity.isNewOfferRb.label": "優惠狀態和有效性",
  "exclusiveAccessAndOffer.offerStatusAnbValidity.isNewOfferRb.tooltip": "選擇優惠狀態和優惠在忠誠錢包中可供成員使用的期間。",
  "exclusiveAccessAndOffer.offerTiersAndValue.points.label": "層級和值",
  "exclusiveAccessAndOffer.offerTiersAndValue.points.tooltip": "選擇您要提供存取的層級和每個層級取得此存取所需的點數。選擇此層級並啟用此優惠後，便會在忠誠錢包中向成員顯示優惠。",
  "exclusiveAccessAndOffer.offerTiersAndValue.other.label": "啟用您要提供免費存取的層級。",
  "exclusiveAccessAndOffer.accessValidity.mainLabel": "存取有效性",
  "exclusiveAccessAndOffer.accessValidity.validityDurationTooltip": "選擇此專屬存取自成員取得存取起的有效性。",
  "exclusiveAccessAndOffer.accessValidity.action.showOnActionCb.label": "啟用存取可用性作為行動獎勵。",
  "exclusiveAccessAndOffer.accessValidity.action.showOnActionCb.tooltip": "若要停用此選項，請中斷專屬存取獎勵與行動的連接：{names}",
  "exclusiveAccessAndOffer.accessValidity.tooltip.connected": "選擇此存取的有效性類型到期存取會自動從忠誠錢包移除。若要停用行動存取可用性，請中斷專屬存取與行動的連接。",
  "exclusiveAccessAndOffer.accessValidity.tooltip": "選擇此存取的有效性類型，到期存取會自動從忠誠錢包移除。",
  "exclusiveAccessAndOffer.title": "存取和優惠",
  "exclusiveAccessAndOffer.alert": "專屬和存取的有效性介於",
  "exclusiveAccessAndOffer.desctiption.limited": "您可提供專屬 URL 存取作為行動、點數或免費的獎勵。請定義並啟用所需存取和優惠。",
  "exclusiveAccessAndOffer.desctiption.permanent": "定義並啟用專屬 URL 所需的存取和優惠，您可同時有多個存取類型。",
  "excluxiveAccessSetupSettings.notice.multimarket": "輸入此專屬的特定市場和 URL，請確保您定義所選市場的所有相關語言。",
  "excluxiveAccessSetupSettings.generalSettings.title": "一般設定",
  "excluxiveAccessSetupSettings.pageSettings.title": "頁面設定",
  "excluxiveAccessSetupSettings.pageSettings.tooltip": "專屬為啟用中後，便會在指定 URL 向沒有存取的成員顯示凍結覆蓋。",
  "excluxiveAccessSetupSettings.market.label": "選擇市場",
  "excluxiveAccessSetupSettings.market.tooltip": "選擇此專屬存取的目標市場。",
  "excluxiveAccessSetupSettings.blocking.isStartsWith.label": "專屬頁面 URL",
  "excluxiveAccessSetupSettings.blocking.landingPageUrl.label": "登陸頁面 URL",
  "excluxiveAccessSetupSettings.blocking.landingPageUrl.tooltip": "成員具有存取時，便會顯示此頁面。",
  "excluxiveAccessSetupSettings.blocking.startsWithAccessUrl.label": "凍結存取並提供以此 URL 開頭的所有頁面專屬存取：",
  "excluxiveAccessSetupSettings.blockingValidity.title": "專屬有效性",
  "excluxiveAccessSetupSettings.blockingValidity.tooltip": "定義啟用中專屬的期間，所有成員的專屬有效性和存取皆相同。到期後，您無法再使用此專屬。",
  "excluxiveAccessSetupSettings.exclusiveAccess.name.label": "專屬名稱",
  "excluxiveAccessSetupSettings.exclusiveAccess.name.tooltip": "在將專屬存取連接至福利、行動和優惠時要使用的此存取內部名稱。",
  "exclusiveAccessSetupSettings.accessName.tooltip": "輸入向成員顯示的此存取名稱。",
  "exclusiveAccessSetupSettings.accessIcon.label": "存取圖示",
  "exclusiveAccessSetupSettings.accessIcon.selectIconText": "新增至存取",
  "exclusiveAccessSetupSettings.validity.blockingValidity.end.label": "專屬有效性",
  "exclusiveAccessSetupSettings.validity.blockingValidity.end.tooltip": "定義啟用中專屬的期間。到期後，存取將提供給每個人，且您無法再次使用此專屬。",
  "exclusiveAccessValidity.title": "啟用",
  "exclusiveAccessValidity.notice": "啟用此專屬頁面後，便會根據設定凍結該頁面和限制存取。\n停用此專屬頁面後，便會移除凍結，所有成員將可使用該頁面。",
  "exclusiveAccessValidity.deactivateDialog.headline": "您確定要停用此專屬嗎？",
  "exclusiveAccessValidity.deactivateDialog.content": "停用此專屬頁面後，便會移除凍結，所有成員將可使用該頁面。",
  "exclusiveAccessValidity.deactivateDialog.confirmLabel": "停用",
  "exclusiveAccessPopupValidator.redirectUrl.presence": "輸入重新導向 URI。",
  "exclusiveAccessPopupValidator.redirectUrl.preurlsence": "輸入有效的重新導向 URL。",
  "externalEventsValidator.name.presence": "輸入外部事件名稱。",
  "excluseiveAccesssValidator.accessValidity.presence": "輸入存取有效性。",
  "excluseiveAccesssValidator.accessValidity.numericality.notInteger": "輸入數字大於零的存取有效性。",
  "excluseiveAccesssValidator.accessValidity.numericality.notGreaterThan": "輸入數字大於零的存取有效性。",
  "excluseiveAccesssValidator.exclusiveOfferMaxDate": "輸入早於專屬存取到期日期的優惠結束日期。",
  "excluseiveAccesssValidator.redemptionConstriants.message.title": "輸入標題。",
  "excluseiveAccesssValidator.redemptionConstriants.message.text": "輸入訊息內文。",
  "excluseiveAccesssValidator.redemptionConstriants.message.accessValidityType": "輸入有效性類型。",
  "excluseiveAccesssValidator.redemptionConstriants.limitValue.presence": "輸入大於零的數字作為顯示數量。",
  "excluseiveAccesssValidator.redemptionConstriants.limitValue.numericality.notInteger": "輸入大於零的數字作為顯示數量。",
  "excluseiveAccesssValidator.redemptionConstriants.limitValue.numericality.notGreaterThan": "輸入大於零的數字作為顯示數量。",
  "excluseiveAccesssValidator.redemptionConstriants.offerValidity.dateRange.messageEmpty": "輸入優惠有效性。",
  "excluseiveAccesssValidator.redemptionConstriants.offerValidity.dateRange.messageRangeNotValid": "啟用中專屬存取的最小時間至少為一小時。",
  "excluseiveAccesssValidator.redemptionConstriants.exclusiveOfferMaxDate": "輸入有效的優惠結束日期。",
  "excluseiveAccesssValidator.redemptionConstriants.value.points.notInteger": "輸入大於零的數字作為點數數量。",
  "excluseiveAccesssValidator.redemptionConstriants.value.points.notGreaterThan": "輸入大於零的數字作為點數數量。",
  "excluseiveAccesssValidator.poolSettingsConstriants.name.presence": "輸入集區名稱。",
  "excluseiveAccesssValidator.poolSettingsConstriants.name.exclusionIgnoreCase": "此名稱已存在，請輸入唯一名稱。",
  "excluseiveAccesssValidator.poolSettingsConstriants.accessName.presence": "輸入存取名稱。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.landingPageUrl.presence": "輸入登陸頁面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.landingPageUrl.url": "輸入有效的登陸頁面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.startsWithAccessUrl.presence": "輸入登陸頁面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.startsWithAccessUrl.url": "輸入有效的登陸頁面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.blocking.startsWithAccessUrl.exclusionOrStartWithIgnoreCase": "此頁面 URL 已在其他專屬中定義，請輸入唯一頁面 URL。",
  "excluseiveAccesssValidator.poolSettingsConstriants.market.presence": "輸入市場。",
  "excluseiveAccesssValidator.poolSettingsConstriants.validity.blockingValidity.dateRange.messageEmpty": "輸入專屬有效性。",
  "excluseiveAccesssValidator.poolSettingsConstriants.validity.blockingValidity.dateRange.messageRangeNotValid": "輸入至少 12 小時的專屬有效性。",
  "excluseiveAccesssValidator.accessValidityConstriants.duration.accessValidity.messageRequired": "輸入數字大於零的存取有效性。",
  "excluseiveAccesssValidator.accessValidityConstriants.duration.accessValidity.messageHigherThanZero": "輸入數字大於零的存取有效性。",
  "excluseiveAccesssValidator.accessValidityConstriants.accessDateRange.messageEmpty": "輸入凍結有效性。",
  "excluseiveAccesssValidator.accessValidityConstriants.accessDateRange.messageRangeNotValid": "輸入至少 12 小時的凍結。",
  "singelRedemtionValue.presence": "輸入數字或停用此層級的優惠。",
  "exclusiveSetupPage.title.new": "新 {value} 存取",
  "stylePickerBar.notificationContent.Member": "覆寫沒有專屬存取忠誠成員的按鈕文字和 URL。",
  "stylePickerBar.notificationContent.nonMember": "覆寫沒有專屬存取非成員的按鈕文字和 URL。",
  "memberModTabs.template.value": "一般：所有畫面上的設計和文字影響。"
}
